import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { informarAction } from '../../../../application/actions/informar';

import { loadersActions } from '../../../../application/actions/ui_loaders';

// import { logReqError } from '../../../ui/utils/functions';

import api from '../../../api';
const apiInformar = api(process.env.REACT_APP_URL);

export function* fetchInformarfun(params) { 
  try { 

    const { trackid, Authorization } = params.payload;
 
    yield put(loadersActions.changeStatusLoaderInformar({ isLoading: true }));

    const { data } = yield call(apiInformar.post,'/resultado/informar', '' , { 
        'Track-Id': trackid,
        Authorization
        
     });

    yield put(loadersActions.changeStatusLoaderInformar({ isLoading: false }));


    if (data) {
      yield put(informarAction.fetchInformarSuccess({ respuestaServicio: data }));

    } else {

      yield put(informarAction.fetchInformarError());

    }

  } catch {
      //Errores
    yield all([
      put(informarAction.fetchInformarError()),
      put(loadersActions.changeStatusLoaderInformar({ isLoading: false }))
    ]);
  }
}

export function* watchFetchGenerarCP() {
  yield takeLatest(informarAction.fetchInformar.type, fetchInformarfun);
}

export default function* rootSaga() {
  yield spawn(watchFetchGenerarCP);
}
